export default defineNuxtRouteMiddleware((to) => {
  const router = useRouter();
  const routes = router.getRoutes();
    
  if (to.path === "/") {
    return;
  }

  if (to.path.startsWith("/ru-by")) {
    return;
  }

  const exists = routes.some(route => {
    return route.path.includes(to.path);
  });

  if (exists) {
    return;
  }

  throw createError({ statusCode: 404, statusMessage: "Page Not Found" });
});